import React, { type PropsWithChildren } from 'react';
import { SearchDialogAnalyticsContext } from '../analytics/search-dialog-analytics-context/search-dialog-analytics-context';

export const QuickFindAnalyticContext: ({ children, isQuickFind, }: PropsWithChildren<{
    isQuickFind?: boolean;
}>) => React.JSX.Element = ({
	children,
	isQuickFind = false,
}: PropsWithChildren<{ isQuickFind?: boolean }>) => (
	<SearchDialogAnalyticsContext
		analyticContext={{ isQuickFind: isQuickFind }}
		nonPrivacySafeAnalyticContext={{}}
	>
		{children}
	</SearchDialogAnalyticsContext>
);
